/**
 * @generated SignedSource<<91c3fe6da3422150de0aefeb3da83b59>>
 * @relayHash cc70f886f5a48b398b5cdf75569624df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aae74ae245fd023e08e32b9c46ad237f06b6fe19c628a5c9b488472e2beb3cf2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type roadmapSettingsQuery$variables = {
  locationAri?: string | null | undefined;
  sourceAri: string;
};
export type roadmapSettingsQuery$data = {
  readonly roadmaps: {
    readonly roadmapForSource: {
      readonly roadmapConfiguration: {
        readonly boardConfiguration: {
          readonly isSprintsFeatureEnabled: boolean | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"childIssuesSchedulingPreview_ProjectSettingsBoardSettingsRoadmap" | "childIssuesSchedulingToggle_ProjectSettingsBoardSettingsRoadmap">;
        };
      };
    } | null | undefined;
  } | null | undefined;
};
export type roadmapSettingsQuery = {
  response: roadmapSettingsQuery$data;
  variables: roadmapSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locationAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "locationARI",
    "variableName": "locationAri"
  },
  {
    "kind": "Variable",
    "name": "sourceARI",
    "variableName": "sourceAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isSprintsFeatureEnabled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "roadmapSettingsQuery",
    "selections": [
      {
        "concreteType": "RoadmapsQuery",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapDetails",
            "kind": "LinkedField",
            "name": "roadmapForSource",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "RoadmapConfiguration",
                  "kind": "LinkedField",
                  "name": "roadmapConfiguration",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "RoadmapBoardConfiguration",
                        "kind": "LinkedField",
                        "name": "boardConfiguration",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "childIssuesSchedulingToggle_ProjectSettingsBoardSettingsRoadmap"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "childIssuesSchedulingPreview_ProjectSettingsBoardSettingsRoadmap"
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                    }
                  ]
                },
                "action": "THROW",
                "path": "roadmaps.roadmapForSource.roadmapConfiguration"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "roadmapSettingsQuery",
    "selections": [
      {
        "concreteType": "RoadmapsQuery",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapDetails",
            "kind": "LinkedField",
            "name": "roadmapForSource",
            "plural": false,
            "selections": [
              {
                "concreteType": "RoadmapConfiguration",
                "kind": "LinkedField",
                "name": "roadmapConfiguration",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "RoadmapBoardConfiguration",
                    "kind": "LinkedField",
                    "name": "boardConfiguration",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isChildIssuePlanningEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "childIssuePlanningMode"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "aae74ae245fd023e08e32b9c46ad237f06b6fe19c628a5c9b488472e2beb3cf2",
    "metadata": {},
    "name": "roadmapSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9114fac2c709c65b2d6e748af5f3fc01";

export default node;
